import React from 'react'
import Modal from 'react-modal'
import $ from 'jquery'

import './ConfirmModal.css'


class ConfirmModal extends React.Component {
    styling = {
        content: {
            top: '172px',
            left: '33px',
            width: '87%',
            height: '24%',
            padding: '16px',
            background: 'white',
        }
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (this.props.msglink) {
            this.styling.content.padding = '0px;';
        }
    }

    render() {
        return (
            <Modal isOpen={this.props.open} style={this.styling}>
                <div className="ConfirmModal">
                    {
                        this.props.msglink ?
                            <p className="msglink">{this.props.heading}</p>
                        :
                            <p>{this.props.heading}</p>
                    }
                    {
                        this.props.msglink ?
                            <div id="body" className="msglink">{this.props.msg}</div>
                        :
                            <div id="body">{this.props.msg}</div>
                    }

                    {
                        this.props.msglink ?
                            <div className="buttons msglink">
                                {
                                    this.props.notifyOnly ?
                                        <button className="btn btn-primary" onClick={this.props.onYes}>Ok</button>
                                        :
                                        <div>
                                            <a className="btn btn-default" onClick={this.props.onNo}>No</a>
                                            <button className="btn btn-primary" onClick={this.props.onYes}>Yes</button>
                                        </div>
                                }
                            </div>
                        :
                            <div className="buttons">
                                {
                                    this.props.notifyOnly ?
                                        <button className="btn btn-primary" onClick={this.props.onYes}>Ok</button>
                                        :
                                        <div>
                                            <a className="btn btn-default" onClick={this.props.onNo}>No</a>
                                            <button className="btn btn-primary" onClick={this.props.onYes}>Yes</button>
                                        </div>
                                }
                            </div>
                    }
                </div>
            </Modal>
        );
    }
}

export default ConfirmModal
